import { Loader } from "@circle-react-shared/uikit/Loader";
import { useHyperDXIdentity } from "@circle-react/hooks/useHyperDXIdentity";
import { useIsMobile } from "@circleco/compass/hooks/useIsMobile";
/**
 * This component is the entry for the new TanStack Router
 * It is used to wrap the main app content and provide the necessary context for the router
 */
import { RouterProvider } from "@tanstack/react-router";

import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { queryClient } from "@/react/providers/QueryClient/reactQueryConfig";
import { routeTree } from "@/react/routeTree.gen";
import { createTanstackRouter } from "@/react/utils/router/createTanstackRouter";

export const router = createTanstackRouter({
  routeTree,
  context: {
    queryClient,
    punditUserContext: undefined,
    isMobile: false,
  },
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }

  interface HistoryState {
    from?:
      | {
          path?: string;
          pathname?: string;
          query?: string;
          search?: string;
        }
      | string;
    prevLocation?: string;
  }
}

export const MainAppRouter = () => {
  const punditUserContext = usePunditUserContext();
  const isMobile = useIsMobile();

  useHyperDXIdentity();

  if (punditUserContext.isLoading)
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader />
      </div>
    );

  return (
    <RouterProvider
      router={router}
      context={{ queryClient, punditUserContext, isMobile }}
    />
  );
};
